module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page"
  }, [_c('div', {
    staticClass: "t1"
  }, [_vm._v("关注微信公众号")]), _vm._v(" "), _c('div', {
    staticClass: "t2"
  }, [_vm._v("更多生命灵粮与您共享")]), _vm._v(" "), (_vm.tip) ? _c('div', {
    staticClass: "t0"
  }, [_vm._v("当前集数已播放完毕，邀请您关注公众号")]) : _c('div', {
    staticClass: "t01"
  }, [_vm._v("下一步")]), _vm._v(" "), _c('div', {
    staticClass: "qrcode"
  }, [_c('img', {
    attrs: {
      "src": _vm.qrcode
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "t3"
  }, [_vm._v("关注指南:")]), _vm._v(" "), _c('div', {
    staticClass: "t4"
  }, [_vm._v("长按识别关注后，请重新进入")]), _vm._v(" "), (_vm.ignore) ? _c('div', {
    staticClass: "btn"
  }, [_c('a', {
    staticClass: "off",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.onCancel
    }
  }, [_vm._v("下次再说")])]) : _vm._e(), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "t5"
  }, [_vm._v("\n    邀请弟兄姊妹关注微信公众号，每日丰富灵粮\n    "), _c('br'), _vm._v("精彩呈现，维护通知同步获取。\n  ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-017913cc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/subscribe/root.vue
// module id = 305
// module chunks = 0